export const UpgradeNowIcon = ({ color = "#D97706" }: { color?: string }) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
  <g clipPath="url(#clip0_3530_4908)">
    <path d="M10.3129 8.24966C10.7279 8.6647 10.7279 9.33872 10.3129 9.75376L3.93788 16.1288C3.52284 16.5438 2.84882 16.5438 2.43378 16.1288C2.01874 15.7137 2.01874 15.0397 2.43378 14.6247L8.05839 9.00005L2.4371 3.37544C2.02206 2.9604 2.02206 2.28638 2.4371 1.87134C2.85214 1.4563 3.52616 1.4563 3.9412 1.87134L10.3162 8.24634L10.3129 8.24966Z" fill={color}/>
  </g>
  <defs>
    <clipPath id="clip0_3530_4908">
      <rect width="10.625" height="17" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
  </defs>
</svg>
    )
}